import { EmptyState, Page, Symbols } from '@mnd-frontend/ui/publish/components';
import { useTranslation } from 'react-i18next';

const Page404 = () => {
  const { t } = useTranslation();
  return (
    <Page>
      <EmptyState
        headline={t('error_404.header')}
        description={t('error_404.explanation')}
        symbol={Symbols.BrokenLink}
      />
    </Page>
  );
};

export default Page404;
